/**
 * API class
 *
 * @class API
 * @singleton
 * @mixins Events
 */

function getDeviceQuery(device) {
    if (device.isSAMSUNG || device.isTIZEN)
    { return 'SAMSUNG'; }
    else if(device.isWEBOS)
    { return 'LG'; }
    else if(device.isLG)
    { return 'LG'; }
    else {
        return 'LG';
    }
}

API = function (Events) {
    var API = {
        config: {
            defaultHeader: {
                headers: {
                    'Content-Type': 'application/json',
                }
            },
            preferedLang: Device.getLanguage()
        }
    };

    $.extend(true, API, Events, {
        /**
		 * To init API
		 * @param {Object} config Hash of parameters
		 */
        init: function (config) {
            // set config object
            this.configure(config);

            this.apiEndpoint = 'https://app.allflamenco.net';
            this.ready();

            // API is ready to use
            //this.ready();
        },

        /**
		 * Set class config hash
		 * @param {Object} config Hash of parameters
		 */
        configure: function (config) {
            this.config = $.extend(true, this.config || {}, config);

            // override when /config is fetched
            this.serverTime = function () {
                return moment().add(this.config.timeOffset(), 'ms').utc();
            }
        },

        /**
		 * API is ready to use
		 */
        ready: function () {
            this.trigger('ready');
        },

        /**
		 * API main function to getting data
		 * @param {String} url suburl for the request this part is appended to the main API url
		 * @param {Object} data JSON object (if it is available) which should be parsed and sent
		 * @param {String} methodType represent Request type (GET|POST|HEAD|etc.)
		 *
		 * @returns {Promise} promise is returned for the next processes
		 */
        request: function (url, methodType, config, data) {
            var requestObject = $.extend({
                method: methodType || 'GET',
                // type: 'json' --- causes jQuery JSON parse error when response is SRT
                data: data,
                cache: true,
                timeout: CONFIG.ajax.timeout || 60000
            }, config);

            return new Promise(function (resolve, reject) {
                Ajax.request(url, requestObject)
                    .then(function (response) {
                    resolve(response);
                }, function (error) {
                    reject(error);
                });
            })
        },

        /**
		 * return UTC time of server
		 * override when /config is fetched
		 * @return {moment Object}
		 */
        serverTime: function () {
            return moment().utc();
        },

        /**
		 * API call for sign in feature
		 * @param {String} username
		 * @param {String} password
		 *
		 * @returns {Promise} promise is returned for the next processes
		 */
        signIn: function (email, password) {
            return new Promise(function (resolve, reject) {
                if (email && password) {
                    App.throbber(false);
                    this.request('https://app.allflamenco.net/graphql', 'GET', { headers: { 'Content-Type': 'application/json' }, processData: true }, {
                    "query" : "mutation { login(data: {username: \"\"  , password: \"\", provider: \"api\"}) {  access_token   token_type   expires_in    refresh_token  }}"
                }).bind(this)
                        .then(function (data) {
                        Storage.set('login_token', data.access_token);
                        console.log("token: " + data.access_token);
                        this.setSecurityHeader(data.access_token);
                        User.signIn(email);
                        App.throbberHide(false);
                        resolve(data);
                    }, function (err) {
                        App.throbberHide(false);
                        App.notification(__(err === 'Unauthorized' ? 'login_failed' : err));
                        reject(err);
                    });
                } else {
                    App.throbberHide(false);
                    reject('No_password')
                }
            }.bind(this));
        },

        signOut: function() {
            return new Promise(function (resolve, reject) {
                this.request('https://app.allflamenco.net/disconnect?token=' + this.getUUID(), 'GET', this.getSecurityHeader(), {} ).bind(this)
                    .then(function (data) {
                    User.signOut();
                    Storage.set('login_token', '');
                    Developer.reload();
                    resolve()
                })
                    .catch(function (err) {
                    User.signOut();
                    Storage.set('login_token', '');
                    Developer.reload();
                    var response = JSON.parse(err.responseText);
                    reject(err);
                })
            }.bind(this))
        },

        /**
		 * API call for free sign in with provided credentials.
		 * @returns {Promise} promise is returned for the next processes
		 */
        freeSignIn: function () {
            return new Promise(function (resolve, reject) {
				this.request('https://app.allflamenco.net/graphql', 'POST', { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, processData: true }, {
                    "query" : "mutation { login(data: {username: \"desarrollo@beatmobile.com.ar\"  , password: \"beatmobile\", provider: \"api\"}) {  access_token   token_type   expires_in    refresh_token  }}"
                }).bind(this)
					.then(function (data) {
						Storage.set('login_token', data.access_token);
						this.setSecurityHeader(data.access_token);
						App.throbberHide(false);
						resolve(data);
					}, function (err) {
						App.throbberHide(false);
						App.notification(__(err === 'Unauthorized' ? 'login_failed' : err));
						reject(err);
					});
			}.bind(this));
        },

        /**
		 * API call to refresh token1.
		 * @returns {Promise} promise is returned for the next processes
		 */
        tokenRefresh: function () {
            var vEmail = Storage.get('email');
            var vId = Storage.get('userId');
            var vUsername = Storage.get('userName');
            if (vEmail && vId && vUsername) {
                User.signIn(vEmail, vId, vUsername);
            }
            this.setSecurityHeader(vId);
            App.throbberHide(false);
        },
        
        getActivationCode: function (searchString) {

            return new Promise(function (resolve, reject) {
                this.request('https://app.allflamenco.net/generate?platform=SAMSUNG&token=' + this.getUUID(), 'GET', this.getSecurityHeader(), {} ).bind(this)
                    .then(function (data) {
                    resolve(data)
                })
                    .catch(function (err) {
                    var response = JSON.parse(err.responseText);
                    reject(err);
                })
            }.bind(this))
        },
        
        checkActivationStatus: function () {
            return new Promise(function (resolve, reject) {
                this.request('https://app.allflamenco.net/authenticate?token=' + this.getUUID(), 'GET', this.getSecurityHeader(), {} ).bind(this)
                    .then(function (data) {
                    resolve(data)
                })
                    .catch(function (err) {
                    var response = JSON.parse(err.responseText);
                    reject(err);
                })
            }.bind(this))
        },

        /**
		 * Sets header needed for authorization in all requests.
		 * @returns {Object} securityHeader
		 */
        setSecurityHeader: function (token) {
            this.securityHeader = { headers: { 'Authorization': 'Bearer ' + token } }
        },

        /**
		 * Gets header needed for authorization in all requests.
		 * @returns {Object} securityHeader
		 */
        getSecurityHeader: function () {
            if (this.securityHeader) return this.securityHeader;
            var token = Storage.get('login_token');
            if (token) {
                this.setSecurityHeader(token);
                return this.securityHeader;
            } else return null;
        },

        getUserName: function() {
            return new Promise(function(resolve, reject) {
                this.request(this.apiEndpoint + 'viewers/user-info', 'GET', this.getSecurityHeader())
                    .bind(this)
                    .then(function(data) {
                    resolve(data.data)
                })
                    .catch(function(err) {
                    reject(err);
                })
            }.bind(this));
        },

        getPlayerProgress: function(userID, videoID) {
            var isTenant = 0;
            userID = userID || 0;
            return new Promise(function (resolve, reject) {
                this.request(this.apiEndpoint + 'plays/time/' + userID + '/' + videoID + '/'+ isTenant, 'GET', this.getSecurityHeader())
                    .then(function (data) {
                    console.log(data);
                    resolve(data);
                })
                    .catch(function (err) {
                    var response = JSON.parse(err.responseText);
                    reject(err);
                })
            }.bind(this))
        },

        /**
		 * Save player progress.
		 * @returns {Promise} promise is returned for the next processes
		 */
        startPlayerProgress: function(vId) {
            return new Promise(function (resolve, reject) {
                this.request('https://app.allflamenco.net/graphql', 'GET', this.getSecurityHeader(), {
                    "query" : "mutation {createReproduction(video_id: "+vId+",current_time: 0){id}}"
                }).bind(this)
                    .then(function (data) {
                    resolve(data)
                })
                    .catch(function (err) {
                    var response = JSON.parse(err.responseText);
                    reject(err);
                })
            }.bind(this))
        },
        savePlayerProgress: function(vId, vTime) {
            return new Promise(function (resolve, reject) {
                this.request('https://app.allflamenco.net/graphql', 'GET', this.getSecurityHeader(), {
                    "query" : "mutation {setUserVideoTime(token: \""+Storage.get('userId')+"\",video_id: "+vId+",current_time: "+vTime+"){id}}"
                }).bind(this)
                    .then(function (data) {
                    resolve(data)
                })
                    .catch(function (err) {
                    var response = JSON.parse(err.responseText);
                    reject(err);
                })
            }.bind(this))
        },

        /**
		 * API call list of plays.
		 * @returns {Promise} promise is returned for the next processes
		 */
        fetchAllPlays: function () {
            return new Promise(function (resolve, reject) {
                this.request('https://app.allflamenco.net/graphql', 'GET', this.getSecurityHeader(), {
                    "query" : "{videosFeatured(flex_application_id: 2) {id name: lang(lang: \""+this.getPreferedLang()+"\", field:\"name\" object: \"App\\\\Video\")                description: lang(lang: \""+this.getPreferedLang()+"\", field:\"description\" object:\"App\\\\Video\")              thumb_url              is_favourite            }          }"
                }).bind(this)
                    .then(function (data) {
                    resolve(data)
                })
                    .catch(function (err) {
                    var response = JSON.parse(err.responseText);
                    if (response.message === 'Token has expired') {
                        this.tokenRefresh().delay(500, this).bind(this).then(function () { return this.fetchAllPlays() }).then(function (data) { resolve(data) }).catch(function (err) { reject(err) });
                    } else reject(err);
                })
            }.bind(this))
        },

        /**
         *
         *
         */
        fetchPlaysSearch: function (searchString) {
            return new Promise(function (resolve, reject) {
                this.request('https://app.allflamenco.net/graphql', 'GET', this.getSecurityHeader(), {
                    "query" : "{videoSearch(lang: \""+this.getPreferedLang()+"\", flex_application_id:  \"2\", search: \""+searchString+"\", excludeCountryCode: \"AR\", count: 250, page: 1)   {paginatorInfo { count, currentPage, hasMorePages, lastPage, total }, data { id, thumb_url, name: lang(lang: \""+this.getPreferedLang()+"\", field:\"name\", object: \"App\\\\Video\"), description: lang(lang: \""+this.getPreferedLang()+"\", field:\"description\", object: \"App\\\\Video\"), duration, slug}}}"
                }).bind(this)
                    .then(function (data) {
                    resolve(data)
                })
                    .catch(function (err) {
                    var response = JSON.parse(err.responseText);
                    if (response.message === 'Token has expired') {
                        this.tokenRefresh().delay(500, this).bind(this).then(function () { return this.fetchPlaysSearch(searchString) }).then(function (data) { resolve(data) }).catch(function (err) { reject(err) });
                    } else reject(err);
                })
            }.bind(this))
        },

        /**
		 * API call list of categories.
		 * @returns {Promise} promise is returned for the next processes
		 */
        fetchAllCategories: function () {
            return new Promise(function (resolve, reject) {
                this.request('https://app.allflamenco.net/roku/get/'+this.getPreferedLang(), 'GET', { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, processData: true })
                    .bind(this)
                    .then(function (data) {
                    resolve(data)
                })
                    .catch(function (err) {
                    var response = JSON.parse(err.responseText);
                    if (response.message === 'Token has expired') {
                        this.tokenRefresh().delay(500, this).bind(this).then(function () { return this.fetchAllCategories() }).then(function (data) { resolve(data) }).catch(function (err) { reject(err) });
                    } else reject(err);
                })
            }.bind(this))
        },

        fetchFavorites: function (searchString) {
            return new Promise(function (resolve, reject) {
                this.request('https://app.allflamenco.net/graphql', 'GET', this.getSecurityHeader(), {
                    "query" : "{favourites {id name: lang(lang: \""+this.getPreferedLang()+"\", field: \"name\" object: \"App\\\\Video\") description: lang(lang: \""+this.getPreferedLang()+"\" field: \"description\" object: \"App\\\\Video\") thumb_url}}"
                }).bind(this)
                    .then(function (data) {
                    resolve(data)
                }).catch(function (err) {reject(err);})
            }.bind(this))
        },

        fetchContinueWatching: function (searchString) {
            return new Promise(function (resolve, reject) {
                this.request('https://app.allflamenco.net/graphql', 'GET', this.getSecurityHeader(), {
                    "query" : "{userVideoTimesByUser {video {id name: lang(lang: \""+this.getPreferedLang()+"\", field: \"name\" object: \"App\\\\Video\") description: lang(lang: \""+this.getPreferedLang()+"\" field: \"description\" object: \"App\\\\Video\") thumb_url is_favourite}}}"
                }).bind(this)
                    .then(function (data) {
                    resolve(data)
                }).catch(function (err) {reject(err);})
            }.bind(this))
        },

        fetchSubtitles: function (url, playId) {
            return new Promise(function (resolve, reject) {
                this.request(CONFIG.subtitlesUrl +playId+ '/subtitles/' + url + '?device=LG', 'GET', {}).then(function (data) {
                    resolve(data);
                }).catch(function (err) {
                    reject(err);
                })
            }.bind(this));
        },

        getPreferedLang: function () {
            switch (this.config.preferedLang.substring(0,2)){
                case 'es':
                    return 'es';
                    break;
                
                case 'ja':
                    return 'ja';
                    break;

                default:
                    return 'en';
                    break;
            }
        },

        getDetailData: function (id) {
            return new Promise(function (resolve, reject) {
                if (id) {
                    this.request('https://app.allflamenco.net/graphql', 'GET', this.getSecurityHeader(), {
                    "query" : "{ video (id: "+id+") {  id , name: lang(lang: \""+this.getPreferedLang()+"\"  , field: \"name\" , object: \"App\\\\Video\" ), description: lang(lang: \""+this.getPreferedLang()+"\"  , field: \"description\" , object: \"App\\\\Video\" ) , video_4k_url, video_url_mp4, video_url, duration, thumb_url, thumb_smarttv_url, is_free, is_favourite, suscriptionPlans: suscriptionPlansCache(platform: WEB) { id } ,dynamic_fields: lang(lang: \""+this.getPreferedLang()+"\", field:\"dynamic_fields\" object: \"App\\\\Video\") }}"
                }).bind(this)
                        .then(function (data) {
                        resolve(data);
                    })
                        .catch(function (err) {
                        var response = JSON.parse(err.responseText);
                        if (response.message === 'Token has expired') {
                            this.tokenRefresh().delay(500, this).bind(this).then(function () {
                                return this.getDetailData(id)
                            }).then(function (data) {
                                resolve(data)
                            }).catch(function (err) {
                                reject(err)
                            });
                        } else reject(err);
                    })
                } else {
                    console.log('Item Id is missing');
                }
            }.bind(this))
        },

        getUserSubscription: function () {
            return new Promise(function (resolve, reject) {
                this.request('https://app.allflamenco.net/graphql', 'GET', this.getSecurityHeader(), {
                    "query" : "{me {id,email,name,language,autologin,userSuscriptionPlans {is_valid date_start date_end videoPPV{id} suscriptionPlan {id platform type name:lang(lang: \""+this.getPreferedLang()+"\", field: \"name\" object: \"App\\\\Video\")}}}}"
                }).bind(this)
                    .then(function (data) {
                    resolve(data)
                })
                    .catch(function (err) {
                    var response = JSON.parse(err.responseText);
                    if (response.message === 'Token has expired') {
                        this.tokenRefresh().delay(500, this).bind(this).then(function () { return this.fetchAllPlays() }).then(function (data) { resolve(data) }).catch(function (err) { reject(err) });
                    } else reject(err);
                })
            }.bind(this))
        },

        saveFavorites: function (id_video) {
            return new Promise(function (resolve, reject) {
                this.request('https://app.allflamenco.net/graphql', 'GET', this.getSecurityHeader(), {
                    "query" : "mutation { updateUser(favorites:[{video_id: "+id_video+"}] ) { name, favorites { id name } } }"
                }).bind(this)
                    .then(function (data) {
                    resolve(data)
                })
                    .catch(function (err) {
                        reject(err);
                })
            }.bind(this))
        },


        saveAndroidProgress: function(jsonString) {

            var JSONdata = JSON.parse(jsonString);
            console.log('[SecondS] ' + JSONdata.seconds);

            var config = {
                userID: JSONdata.userID,
                playID: JSONdata.playID,
                seconds: JSONdata.seconds
            }

            App.provider.savePlayerProgress(config)
                .bind(this)
                .then(function(data) {
                console.log(JSON.stringify(data));
            }).catch(function(err) {
                console.log('android save progress failed: ' + err);
            });

            return 'ok';
        },
        
        setCookie: function(cname, cvalue, exdays) {
            
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires="+d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },

        getCookie: function(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for(var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    console.log(c.substring(name.length, c.length));
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        
        getUUID: function() {
            if(Storage.get('UUID')){
                return Storage.get('UUID');
            } else {
                Storage.set('UUID', this.UUIDv4());
                return Storage.get('UUID');
            }
        },
        
        UUIDv4: function() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }
        
    });

    return API;

}(Events);



//////////////////
// WEBPACK FOOTER
// ./js/module/api.js
// module id = 48
// module chunks = 0